module.exports = require("next/dist/compiled/@next/react-dev-overlay/dist/middleware");